import { configureStore } from "@reduxjs/toolkit";
import ticketsSlice from "../features/tickets/ticketsSlice";

export const store = configureStore({
  reducer: {
    tickets: ticketsSlice,
    },
});

